'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DescriptionCharacterLimitExceededAlert = require('./components/DescriptionCharacterLimitExceededAlert.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DescriptionCharacterLimitExceededAlert).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/description-character-limit-exceeded-alert/index.js
// module id = 1289
// module chunks = 0